import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=59792098"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CourseList.vue?vue&type=custom&index=0&blockType=title"
if (typeof block0 === 'function') block0(component)
import block1 from "./CourseList.vue?vue&type=custom&index=1&blockType=layout"
if (typeof block1 === 'function') block1(component)

export default component.exports